<template>
  <span
    v-if="status_id == 0"
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-yellow-100 text-yellow-800"
  >
    {{ prepend_label }} Preparando
  </span>
  <span
    v-if="status_id == 1"
    class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-green-100 text-green-800"
  >
    {{ prepend_label }} Cargado
  </span>
</template>

<script>
export default {
  name: "AEProductionQueryContainerExportContainerStatus",
  props: ["status_id", "prepend_label"]
};
</script>
